import { createSlice } from '@reduxjs/toolkit';

import { handleGetSupplementCategories } from './actions';
import { ISupplementCategoriesState } from './slice.interface';

const initialState: ISupplementCategoriesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const supplementCategoriesSlice = createSlice({
  name: 'supplement-categories',
  initialState,
  reducers: {
    removeSupplementCategories: (state: ISupplementCategoriesState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetSupplementCategories.pending, (state: ISupplementCategoriesState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetSupplementCategories.rejected, (state: ISupplementCategoriesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(
        handleGetSupplementCategories.fulfilled,
        (state: ISupplementCategoriesState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
          state.isReady = true;
        },
      );
  },
});

export const { removeSupplementCategories } = supplementCategoriesSlice.actions;

export default supplementCategoriesSlice.reducer;
